// servicePageData.js

export const ServicListAR = [
  {
    id: 1,
    slug: "mobile-applications",
    title: "تطبيقات الجوال",
    img: require("../assests/androidApp-EN.JPG"),
    small_description: "إنشاء تطبيقات خالية من الأعطال لأنظمة: ios/ Android بكفاءة عالية وتصاميم مميزة وسهلة الإستخدام",
    description: "نطور تطبيقات جوال احترافية لأنظمة iOS و Android تجمع بين الأداء العالي، التصميم العصري، وسهولة الاستخدام. نبدأ من الفكرة ونصل إلى النشر في المتاجر، مع دعم فني مستمر وتحديثات دورية لضمان تجربة مستخدم استثنائية."
  },
  {
    id: 2,
    slug: "websites",
    title: "مواقع إلكترونية",
    img: require("../assests/webSite-AR.jpg"),
    small_description: "متجر إلكتروني لعرض المنتجات، صفحات تعريفية لعرض الخدمات، برمجة خاصة لكل عميل بالميزات التي يطلبها",
    description: "نُصمم ونطور مواقع إلكترونية متجاوبة وسريعة، سواء كانت متاجر إلكترونية أو مواقع تعريفية، مع دعم كامل لتحسين محركات البحث (SEO)، أنظمة إدارة المحتوى (CMS)، وتكامل مع بوابات الدفع المحلية والعالمية."
  },
  {
    id: 3,
    slug: "accounting-system",
    title: "أنظمة محاسبية",
    img: require("../assests/accountingSystem-AR.jpg"),
    small_description: "تخزين البيانات، إدارة المخزون، إصدار الفواتير، تبسيط العمليات الحسابية، الوصول السريع للمعلومات، أشعارات بكافة التفاصيل، جرد مستمر، إصدار التقارير والتحاليل المالية، وكافة الميزات التي تسهل المهام المحاسبية",
    description: "نقدم أنظمة محاسبية متكاملة تُبسّط العمليات المالية اليومية، تُدير الفواتير، المخزون، المصروفات، والإيرادات بدقة عالية، مع تقارير مالية فورية ودعم لمعايير المحاسبة السعودية، مما يوفر لك رؤية واضحة لأداء عملك في أي وقت."
  },
  {
    id: 4,
    slug: "erp-system",
    title: "نظام ERP",
    img: require("../assests/erp-EN.JPG"),
    small_description: "نظام تقني متكامل يخدم جميع أقسام المنشأة مثل إدارة الموارد البشرية، تنظيم علاقة الموردين، تخطيط المهام، تنظيم الشؤون الإدارية، حصر شامل ودقيق للأمور المالية، إدارة المشروعات وتفاصيلها، إدارة شؤون العملاء، التحاليل وإصدار التقارير الدائمة",
    description: "نظام ERP مخصص يربط جميع إدارات شركتك في منصة واحدة: الموارد البشرية، المالية، المبيعات، المشتريات، المشاريع، والمخازن. يُقلل التكاليف، يرفع الكفاءة، ويُمكّنك من اتخاذ قرارات ذكية بناءً على بيانات حية ودقيقة."
  },
  {
    id: 5,
    slug: "desktop-applications",
    title: "تطبيقات سطح المكتب",
    img: require("../assests/desktop-EN.JPG"),
    small_description: "مخصص للشركات التي تسعى لتوفير تطبيقاتها على أجهزة الكمبيوتر، أو يرغبون بصنع تطبيق خاص بهم لتأدية مهام محددة بتفاصيل تخدم نطاق عملهم",
    description: "نطور تطبيقات سطح مكتب قوية وآمنة تعمل على أنظمة Windows و macOS، مصممة خصيصًا لتلبية احتياجاتك التشغيلية المعقدة، مع واجهات سهلة، أداء عالي، وقدرة على التكامل مع أنظمتك الحالية."
  },
  {
    id: 6,
    slug: "quality-testing",
    title: "اختبار الجودة",
    img: require("../assests/check-quality-EN.JPG"),
    small_description: "إختبار شامل ومتعدد يمر بعدة مراحل ليكشف الأخطاء داخل شبكتك البرمجية قبل ظهور إخلال كبير ويقوم بتصحيحها ليضمن عودة تشغيلها بكفاءة أعلى",
    description: "فريق اختبار جودة متخصص يقوم باختبارات يدوية وأوتوماتيكية شاملة لاكتشاف الثغرات، الأخطاء الوظيفية، مشاكل الأداء، وثغرات الأمان قبل إطلاق أي منتج، لضمان جودة عالية وتجربة مستخدم خالية من العيوب."
  },
  {
    id: 7,
    slug: "maintenance-and-support",
    title: "الصيانة والدعم",
    img: require("../assests/support-EN.JPG"),
    small_description: "صيانة تقنية لكافة الأعطال البرمجية وتحديث الأنظمة مع التطورات",
    description: "نقدم خدمات صيانة ودعم فني مستمرة لأنظمتك وتطبيقاتك، مع استجابة سريعة لأي أعطال، تحديثات دورية، تحسينات أمنية، ودعم فني عبر قنوات متعددة لضمان استمرارية عملك دون انقطاع."
  },
  {
    id: 8,
    slug: "advertising-campaign-production",
    title: "إنتاج الحملات الإعلانية",
    img: require("../assests/ads-EN.JPG"),
    small_description: "نقل صورة إبداعية تخيلية، مكونة من سيناريو وإخراج تصويري ودعم فني صوتي، وتكاتف فريق متكامل، للخروج بأفضل نتيجة إعلانية تترصد ملايين المشاهدات",
    description: "نُنتج حملات إعلانية احترافية من الفكرة إلى العرض النهائي، تشمل كتابة السيناريو، التصوير، المونتاج، المؤثرات الصوتية والبصرية، والتوزيع عبر المنصات الرقمية، لضمان وصول رسالتك للجمهور المستهدف بأعلى تأثير."
  },
  {
    id: 9,
    slug: "search-engine-optimization-seo",
    title: "تحسين محركات البحث SEO",
    img: require("../assests/seo-EN.JPG"),
    small_description: "نحسن محركات بحثك ليسهل على المستخدمين العثور عليك بجهود تقنية وتسويقية مشتركة لزيادة فرص ظهورك في أعلى قوائم المتصفح.",
    description: "نُحسّن موقعك ليظهر في نتائج البحث الأولى عبر استراتيجيات تقنية (تحسين السرعة، البنية، الروابط) ومحتوى محسّن بالكلمات المفتاحية المناسبة، مما يزيد الزيارات العضوية ويعزز مصداقيتك أمام جمهورك."
  },
  {
    id: 10,
    slug: "social-media-management",
    title: "إدارة منصات التواصل الإجتماعي",
    img: require("../assests/social-EN.JPG"),
    small_description: "نزيح عنك عبئ الترويج ونشر المحتوى والتفاعل مع العملاء، بإدارة شاملة تحافظ على نشاطك الدائم في المنصات",
    description: "ندير حساباتك على منصات التواصل الاجتماعي بشكل احترافي: تخطيط المحتوى، التصميم، النشر، التفاعل مع الجمهور، تحليل الأداء، وتشغيل الإعلانات الممولة، لبناء هوية قوية وزيادة ولاء العملاء."
  },
  {
    id: 11,
    slug: "email-campaigns",
    title: "حملات البريد الإلكتروني",
    img: require("../assests/email-EN.JPG"),
    small_description: "يتم إطلاقها لتذكير العملاء الحاليين وتعزيز ولائهم وتواصلك المتواتر معهم للترويج لخدماتك واطلاعهم على أهم الأحداث بشكل مستمر",
    description: "نُنشئ ونُطلق حملات بريد إلكتروني مخصصة ومُوجّهة، تساعدك على بناء علاقة دائمة مع عملائك، تعزيز المبيعات، إعلان العروض، وزيادة التفاعل عبر قنوات اتصال مباشرة وفعّالة."
  },
  {
    id: 12,
    slug: "creative-content-creation",
    title: "إنشاء محتوى إبداعي",
    img: require("../assests/content-EN.JPG"),
    small_description: "عرض خدماتك ومنتجاتك بشكل جذاب، من خلال صنع محتوى رقمي متكامل بإستراتيجيات مدروسة، ومن قبل مصممين متخصصين في المجال",
    description: "فريق إبداعي يُنتج محتوى رقمي عالي الجودة: منشورات، فيديوهات، إنفوجرافيك، ونصوص تسويقية، مصممة لجذب الجمهور، إيصال رسالتك بوضوح، وتحفيز التفاعل والتحويلات."
  },
  {
    id: 13,
    slug: "product-photography",
    title: "تصوير المنتجات",
    img: require("../assests/products-EN.JPG"),
    small_description: "نصور بأعلى مستويات الجودة وبتهيئة أجواء للصورة بديكورات منسقة لدى مصورين ومصممين محترفين",
    description: "تصوير احترافي للمنتجات في استوديو مجهز، مع إضاءة دقيقة، خلفيات مناسبة، ومعالجة ما بعد الإنتاج لعرض منتجاتك بأفضل صورة ممكنة، مما يعزز ثقة العملاء ويزيد المبيعات."
  },
  {
    id: 14,
    slug: "logo-design",
    title: "تصميم الشعار",
    img: require("../assests/design-logo-EN.JPG"),
    small_description: "نخطط شعارات مميزة تلخص معنى العلامة التجارية، ويتم إنشاؤها خطوة بخطوة معك وبتنفيذ عدة أمثلة توصلك إلى القرار المناسب",
    description: "نُصمم شعارات فريدة تعكس هوية علامتك التجارية، عبر دراسة متأنية لنشاطك، جمهورك، وقيمك، ثم نقدم لك عدة مقترحات حتى تختار التصميم الذي يعبر عنك بدقة واحترافية."
  },
  {
    id: 15,
    slug: "media-coverage",
    title: "التغطيات الإعلامية",
    img: require("../assests/Media Coverage-AR.JPG"),
    small_description: "فريق مجهز لتوثيق الحدث من عدة زوايا وبأجهزة صوت وكاميرات حديثة تضمن لك التقاطات مثالية، وتنقل الحدث بدقة عالية.",
    description: "نوثّق فعالياتك ومؤتمراتك وورش العمل عبر فريق إعلامي محترف مزود بأحدث الكاميرات والمعدات الصوتية، لنقدم لك تغطية شاملة تُظهر الحدث بأبهى صورة وتساعدك في الترويج له لاحقًا."
  },
  {
    id: 16,
    slug: "visual-identity-design",
    title: "تصميم هوية بصرية",
    img: require("../assests/Visual-design-EN.JPG"),
    small_description: "إستخلاص ألوان الهوية التجارية وتنفيذ تصاميم مناسبة لها وتطبيقها على عدة عناصر",
    description: "نُطور هوية بصرية متكاملة لعلامتك التجارية تشمل: الشعار، الألوان، الخطوط، الأنماط البصرية، ودليل الاستخدام، ثم نطبقها على جميع عناصرك (الورقي، الرقمي، الإعلاني) لضمان اتساق بصري يعزز مصداقيتك."
  }
];

export const ServicListEN = [
  {
    id: 1,
    slug: "mobile-applications",
    title: "Mobile Applications",
    img: require("../assests/androidApp-AR.jpg"),
    small_description: "Creating flawless applications for iOS/Android systems with high efficiency, distinctive designs, and user-friendly interfaces.",
    description: "We develop professional mobile applications for iOS and Android that combine high performance, modern design, and intuitive user experience. From concept to app store deployment, we provide end-to-end development with ongoing support and regular updates."
  },
  {
    id: 2,
    slug: "websites",
    title: "Websites",
    img: require("../assests/webSite-AR.jpg"),
    small_description: "An online store to display products, informational pages to showcase services, and custom programming for each client with the features they request.",
    description: "We design and develop responsive, fast-loading websites—whether e-commerce stores or corporate sites—with full SEO optimization, CMS integration, and seamless payment gateway support for local and international transactions."
  },
  {
    id: 3,
    slug: "accounting-system",
    title: "Accounting System",
    img: require("../assests/accountingSystem-AR.jpg"),
    small_description: "Storing data, managing inventory, issuing invoices, simplifying calculations, quick access to information, notifications with all details, continuous inventory tracking, generating reports and financial analyses, and all features that facilitate accounting tasks.",
    description: "Our integrated accounting system simplifies daily financial operations—managing invoices, inventory, expenses, and revenues with high accuracy. It provides instant financial reports and complies with Saudi accounting standards for full business visibility."
  },
  {
    id: 4,
    slug: "erp-system",
    title: "ERP System",
    img: require("../assests/erp-AR.jpg"),
    small_description: "An integrated technical system that serves all departments of an organization, such as human resources management, organizing supplier relationships, task planning, administrative affairs management, comprehensive and accurate financial tracking, project management and its details, customer affairs management, and generating ongoing analyses and reports.",
    description: "A customized ERP system that unifies all your departments—HR, finance, sales, procurement, projects, and inventory—into one platform. It reduces costs, boosts efficiency, and enables data-driven decisions with real-time insights."
  },
  {
    id: 5,
    slug: "desktop-applications",
    title: "Desktop Applications",
    img: require("../assests/desktop-AR.jpg"),
    small_description: "Tailored for companies seeking to provide their applications on computers or those who wish to create a custom application to perform specific tasks with details that cater to their scope of work.",
    description: "We build powerful, secure desktop applications for Windows and macOS, tailored to your complex operational needs, with intuitive interfaces, high performance, and seamless integration with your existing systems."
  },
  {
    id: 6,
    slug: "quality-testing",
    title: "Quality Testing",
    img: require("../assests/check-quality-AR.jpg"),
    small_description: "Comprehensive and multi-stage testing that goes through several phases to uncover errors within your software network before a major disruption occurs. It corrects these errors to ensure the system operates with higher efficiency.",
    description: "Our QA team conducts thorough manual and automated testing to detect functional bugs, performance issues, and security vulnerabilities before launch—ensuring a flawless, reliable user experience."
  },
  {
    id: 7,
    slug: "maintenance-and-support",
    title: "Maintenance and Support",
    img: require("../assests/support-AR.jpg"),
    small_description: "Technical maintenance for all software malfunctions and system updates to keep up with advancements.",
    description: "We offer ongoing maintenance and technical support for your systems and applications—including rapid bug fixes, security patches, performance upgrades, and 24/7 technical assistance to ensure uninterrupted operations."
  },
  {
    id: 8,
    slug: "advertising-campaign-production",
    title: "Advertising Campaign Production",
    img: require("../assests/ads-AR.jpg"),
    small_description: "Transforming a creative and imaginative concept into reality, consisting of a script, photographic direction, and audio technical support, along with the collaboration of an integrated team, to deliver the best advertising outcome aimed at capturing millions of views.",
    description: "We produce high-impact advertising campaigns from concept to final delivery—including scripting, filming, editing, voice-over, and digital distribution—to maximize reach, engagement, and brand recall."
  },
  {
    id: 9,
    slug: "search-engine-optimization-seo",
    title: "Search Engine Optimization (SEO)",
    img: require("../assests/seo-AR.jpg"),
    small_description: "We enhance your search engines to make it easier for users to find you through combined technical and marketing efforts, increasing your chances of appearing at the top of browser rankings.",
    description: "We optimize your website to rank higher on search engines using technical improvements (speed, structure, links) and keyword-rich content strategies—driving organic traffic and building trust with your audience."
  },
  {
    id: 10,
    slug: "social-media-management",
    title: "Social Media Management",
    img: require("../assests/social-AR.jpg"),
    small_description: "We take the burden of promotion, content publishing, and customer interaction off your shoulders with comprehensive management that ensures your constant activity on the platforms.",
    description: "We professionally manage your social media accounts—planning content, designing visuals, scheduling posts, engaging with followers, analyzing performance, and running paid ads to build a strong, active brand presence."
  },
  {
    id: 11,
    slug: "email-campaigns",
    title: "Email Campaigns",
    img: require("../assests/email-AR.jpg"),
    small_description: "These are launched to remind current customers, enhance their loyalty, and maintain regular communication with them to promote your services and keep them informed about the most important events on an ongoing basis.",
    description: "We create and execute targeted email campaigns to nurture customer relationships, promote offers, announce events, and drive conversions through personalized, timely, and effective communication."
  },
  {
    id: 12,
    slug: "creative-content-creation",
    title: "Creative Content Creation",
    img: require("../assests/content-AR.jpg"),
    small_description: "Presenting your services and products in an appealing way by producing integrated digital content with well-thought-out strategies, crafted by specialized designers in the field.",
    description: "Our creative team produces high-quality digital content—posts, videos, infographics, and copy—that captures attention, communicates your message clearly, and drives audience engagement and action."
  },
  {
    id: 13,
    slug: "product-photography",
    title: "Product Photography",
    img: require("../assests/products-AR.jpg"),
    small_description: "We capture images at the highest quality levels, creating atmospheres for the photos with coordinated decor, handled by professional photographers and designers.",
    description: "Professional product photography in a fully equipped studio—with precise lighting, curated backgrounds, and post-production editing—to showcase your products in the best possible light and boost customer confidence."
  },
  {
    id: 14,
    slug: "logo-design",
    title: "Logo Design",
    img: require("../assests/design-logo-AR.jpg"),
    small_description: "We plan distinctive logos that encapsulate the essence of the brand, created step-by-step with you and by executing several examples to guide you to the right decision.",
    description: "We design unique logos that reflect your brand’s identity through in-depth research, multiple concepts, and collaborative refinement—delivering a symbol that resonates with your audience and stands the test of time."
  },
  {
    id: 15,
    slug: "media-coverage",
    title: "Media Coverage",
    img: require("../assests/Media Coverage-EN.jpg"),
    small_description: "A fully equipped team to document the event from multiple angles with modern audio and camera equipment, ensuring perfect captures and delivering the event with high precision.",
    description: "Our media team professionally documents your events with multi-angle filming, high-quality audio, and modern equipment—delivering polished coverage that highlights your event’s success and supports future marketing."
  },
  {
    id: 16,
    slug: "visual-identity-design",
    title: "Visual Identity Design",
    img: require("../assests/Visual-design-AR.jpg"),
    small_description: "Extracting the brand's identity colors, creating suitable designs for it, and applying them across various elements.",
    description: "We develop a complete visual identity system—including logo, color palette, typography, and usage guidelines—and apply it consistently across all digital, print, and promotional materials for a unified, professional brand image."
  }
];